import React from 'react';
import { graphql } from 'gatsby';

import Page from '../components/global/page';
import ContactTemplate from '../templates/contact-template';

export default ({ data }) => {
	return (
		<Page title={data.copy.title}>
			<ContactTemplate copy={data.copy} locations={data.locations.nodes} />
		</Page>
	);
};

export const ContactQuery = graphql`
	{
		copy: pagesJson(page: { eq: "contact" }) {
			title
			top
			heading
		}
		locations: allLocationsJson(sort: { fields: title, order: ASC }) {
			nodes {
				title
				contact {
					hours
					location
					phone {
						formatted
						raw
					}
				}
			}
		}
	}
`;
